import React from 'react'

export default function HomeHelp() {
  return (
    <div>
      <h1>Chat de ayuda</h1>
    </div>
  )
}
